import React, { useEffect, useRef, useState } from "react";
import "./banner.scss";
import logo from "../../assets/images/maersk-logo.png";

const Banner = React.memo(() => {
  const videoRef = useRef(null);
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // Local file
    video.src = "/freight.mp4";

    // Poster shows IMMEDIATELY because video is visible from the start
    const handleLoadedData = () => {
      // Fade-in only when first frame is fully decodable
      setFadeIn(true);
    };

    const handleError = () => {
      console.error("Video failed to load, keeping poster visible.");
      setFadeIn(true); 
    };

    video.addEventListener("loadeddata", handleLoadedData);
    video.addEventListener("error", handleError);

    // Autoplay attempt
    video.play().catch(() => {});

    return () => {
      video.removeEventListener("loadeddata", handleLoadedData);
      video.removeEventListener("error", handleError);
    };
  }, []);

  return (
    <div className="afr-banner-wrapper">
      <div className="afr-banner-frame">
        <div className="afr-banner-video-container">

          <video
            ref={videoRef}
            className="afr-banner-video"
            autoPlay
            loop
            muted
            playsInline
            preload="none"
            poster="/freight_poster.jpg"
            style={{
              opacity: fadeIn ? 1 : 1,   
              transition: "opacity 0.6s ease"
            }}
          />

          <img src={logo} alt="Maersk Logo" className="afr-banner-logo" />
          <div className="afr-banner-text">Welcome to AFR Digital Assistant.</div>
        </div>
      </div>
    </div>
  );
});

export default Banner;
